import { useContext, createContext } from 'react';

import type { AppConfiguration } from '../models/AppConfiguration';

export const configurationContext = createContext<AppConfiguration>({
  identityUrl: '',
  tenant: '',
  globalApiUrl: '',
  staticApiUrl: '',
  graphqlUrl: '',
  kpiApiUrl: '',
  localApiUrl: '',
  onBehalfCustomerId: '',
  uriTemplate: '',
  placement: '',
  currentLanguage: '',
  customerId: 0,
  utcOffset: '',
});

export const ConfigurationProvider = configurationContext.Provider;

export const useConfiguration = () => useContext(configurationContext);
